import { Component, OnInit } from '@angular/core';
import { OrganizationService } from '../../shared/services/organization.service';
import { Router, ActivatedRoute, Params, RouterLink} from '@angular/router';
import { Team } from 'app/organization/new-team/mockTeam';
import { MatDialog} from '@angular/material';
import { AssignTeamComponent } from '../Popups/assign-team/assign-team.component';
import { NotificationService } from '../../shared/services/notification.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import {Sort} from '@angular/material';
import { Configuration } from '../../app.constants';

@Component({
  selector: 'app-team-unassigned-associates',
  templateUrl: './team-unassigned-associates.component.html',
  styleUrls: ['./team-unassigned-associates.component.css']
})
export class TeamUnassignedAssociatesComponent implements OnInit {
  public associateSearch;
  public jobCategoryFilter;
  public countryFilter;
  public organizationId: string;
  public organization: any;
  public teams = [];
  public organizationAssociates = [];
  public associates = [];
  public uniqueAssociates: any;
  public unassignedAssociates = [];
  public staticDDlist;
  public startMemberIndex= 0;
  // variables for pagination
  public pageSize = 10;
  public pageSizeOptions = [5, 10, 25, 100];
  public serverApiUrl;
 
  constructor( public organizationService: OrganizationService,
              public route: ActivatedRoute,
              public notificationService: NotificationService,
              public dialog: MatDialog,
              public staticDataService: StaticValueService,
              public config: Configuration) { }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    this.staticDDlist = this.staticDataService.staticData.staticDD;
    this.route.params.subscribe(params => {
      this.organizationId = params['organization_id'];
    });
    this.organizationService.getOrganization(this.organizationId).subscribe((data) =>  {
      this.organization = data['data'][0];
      this.teams = data['data'][0].teams.filter(team => team.active === true);
      this.organizationAssociates = data['data'][0].associates;
      this.teams.forEach(team => {
        team.members.associates.forEach(
          assc => {
            this.associates.push(assc.id);
          }
        );
      });
      this.uniqueAssociates = new Set(this.associates);
      this.organizationAssociates.forEach(assc => {
       if (this.uniqueAssociates.has(assc.associateId)) {
       } else {
        this.unassignedAssociates.push(assc);
       }
      });
      console.log('Unassigned Associates', this.unassignedAssociates);
    }, (error) => {
    });
  }
  assignToTeam(associate: any, index: number) {
    const dialogRef = this.dialog.open(AssignTeamComponent, {
      width: '450px',
      data: {teams: this.teams}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Cancel') {
      } else  {
        let temp = {'id': associate.associateId};
        result.members.associates.push(temp);
        this.notificationService.sendNotification(associate.associateId,
          `You have been added to <b> ${result.teamDetail.name}</b>`, 'Organization',
          `home/organization/team-profile/edit/${result._id}/${this.organizationId}`);

        this.organizationService.updateTeam(this.organizationId, result._id, result, result.members.associates).subscribe((data) => {
          this.unassignedAssociates.splice(index, 1 );
        }, ( error) => {
        });
      }
    });
  }

  getServerData(event) {
    console.log(event.pageSize)
    this.pageSize = event.pageSize;
    this.startMemberIndex = event.pageIndex * event.pageSize;
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }

  sortData(sort: Sort) {
    let data = Object.assign([], this.unassignedAssociates);
    if (!sort.active || sort.direction === '') {
      this.unassignedAssociates = this.unassignedAssociates;
      return;
    }
    let isAsc = sort.direction === 'asc';
    let sortedList = data.sort((a, b) => {
        switch (sort.active) {
          case 'name': return this.compare(a.name.toLowerCase(), b.name.toLowerCase(), isAsc);
          case 'jobCategory': return this.compare(a.jobCategory.toLowerCase(), b.jobCategory.toLowerCase(), isAsc);
          case 'country': return this.compare(a.country.toLowerCase(), b.country.toLowerCase(), isAsc);
          default: return 0;
        }
    });
    this.unassignedAssociates = sortedList;
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
